import { normalize, schema } from 'normalizr';
import { matchSchema } from '../../models/match';
import { createMemberSchema } from '../../models/member/member.schema';
import { pictureSchema } from '../../models/picture';
import { memberSerializer } from '../helper';
import { IApiMatchListResult } from './matchList.types';

const matchListSchema = new schema.Object({
  data: [matchSchema],
  included: new schema.Array(
    {
      member: createMemberSchema(memberSerializer),
      picture: pictureSchema,
    },
    'type'
  ),
});

export const matchListNormalizer = (matchList: IApiMatchListResult) =>
  normalize(matchList, matchListSchema);
